// imgs:[
//   "/images/燕窝/展示/燕窝-泡发图/mmexport1558049524889.jpg",
//   "/images/燕窝/展示/燕窝-泡发图/mmexport1558049531798.jpg",
//   "/images/燕窝/展示/燕窝-泡发图/mmexport1571563262845.jpg",
//   "/images/燕窝/展示/燕窝-泡发图/mmexport1571995192437.jpg",
//   "/images/燕窝/展示/燕窝-泡发图/mmexport1571995198281.jpg",
//   "/images/燕窝/展示/燕窝-泡发图/mmexport1571995200889.jpg",
//   "/images/燕窝/展示/燕窝-泡发图/mmexport1572043763067.jpg",
//   "/images/燕窝/展示/燕窝-泡发图/mmexport1572043767971.jpg",
//   "/images/燕窝/展示/燕窝-泡发图/mmexport1572043816418.jpg",
// ]
const yanwo = {
  imgs:[
    "/images/燕窝/展示/燕窝-泡发图/mmexport1558049524889.jpg",
    "/images/燕窝/展示/燕窝-泡发图/mmexport1558049531798.jpg",
    "/images/燕窝/展示/燕窝-泡发图/mmexport1571563262845.jpg",
    "/images/燕窝/展示/燕窝-泡发图/mmexport1571995192437.jpg",
    "/images/燕窝/展示/燕窝-泡发图/mmexport1571995198281.jpg",
    "/images/燕窝/展示/燕窝-泡发图/mmexport1571995200889.jpg",
    "/images/燕窝/展示/燕窝-泡发图/mmexport1572043763067.jpg",
    "/images/燕窝/展示/燕窝-泡发图/mmexport1572043767971.jpg",
    "/images/燕窝/展示/燕窝-泡发图/mmexport1572043816418.jpg",
  ],
  dunzhu:[
    {
      title:"泡发",
      desc:"正常情况下泡发需要8-10小时，如果的忘记计算时间过一夜也是没关系的。完全泡发与否和水温关系很大，如果水温偏低可以加一点温水。在泡发到一定程度以后可以撕开来的时候，延着燕窝的纹理慢慢撕开尽量不要拉断，有硬心的地方可以用手凑开，直到燕窝完全撕开。\n泡发过程中一定要换水至少3-4次。燕窝的营养并不太溶于水，所以不用担心泡的久和换水多而流失营养，相反洗的次数多一点可以把干燕窝里面不好的亚硝酸盐完全洗掉，因为亚硝酸盐极易溶于水，基本上换过3次水以后就不会有啦。",
      src:"/images/燕窝/展示/燕窝-泡发图/mmexport1558049524889.jpg",
    },
    {
      title:"炖煮",
      desc:"燕窝有很多顿法，最简单实用的就是清炖，万变不离其中，大部分我们看到的外面那些很好看的花式燕窝甜品其实都是分开炖的。燕窝在炖煮过程中还会有第二次泡发。任何含糖份的东西都会影响其第二次膨胀。比如很多人和红枣一起炖，结果燕窝炖出来有点脆脆的感觉就是没有第二次膨胀。清炖还有一个好处就是可以延长保质期，收冰箱一个星期完全没问题。而且特别适合“懒人”，一周炖一次，而且每天可以有不同的吃法。下面说下炖煮时间：正常的炖煮时间为水开以后30-40分钟左右。可以根据自己喜爱的口感延长和缩短炖煮时间。还有隔水炖的时候一定要加盖子，可以防止水蒸气滴入炖盅里面，现在淘宝卖的20几块钱的小炖盅都带有双层盖子啦，非常的贴心。",
      src:"/images/燕窝/展示/燕窝-泡发图/mmexport1558049524889.jpg",
    },
    {
      title:"水量",
      desc:"很多亲掌握不好这个燕窝炖煮时需要加多少水，第一个原则就是不要加太多水，清炖的时候燕窝炖厚一点比较好，也方便后面配牛奶。实践证明合适的水量对燕窝的第二次膨胀也是有很大帮助的。水太多也不利于燕窝第二次膨胀。基本小原则水刚刚没过燕窝即可。",
      src:"/images/燕窝/展示/燕窝-泡发图/mmexport1558049524889.jpg",
    },
    {
      title:"泡发时用的水",
      desc:"泡发用水最基本的是用可以饮用的水，国内最好是纯净水，或者可以用烧过的凉白开，或者买的瓶装饮用水都可以。欧洲的朋友可以直接用水龙头水，或者烧过凉开水，也可以用矿泉水。一般来水纯净水是最有利于燕窝完全泡发。",
      src:"/images/燕窝/展示/燕窝-泡发图/mmexport1558049524889.jpg",
    },
  ],
  galery:{
    imgs:[
      "/images/燕窝/图库/000fe23142343ccdaa910b71abdb7719.jpg",
      "/images/燕窝/图库/VVIP超大盏.jpg",
      "/images/燕窝/图库/mmexport1585304599806.jpg",
      "/images/燕窝/图库/046a2f9381f8c7b93ccff1556fb66b63.jpg",
      "/images/燕窝/图库/e20e966d973607ddbd867e04f1cc0c0c.jpg",
      "/images/燕窝/图库/mmexport1586958746207.jpg",
      "/images/燕窝/图库/0c3b8a7d9e272295c85a40a09ac511b3.jpg",
      "/images/燕窝/图库/1.jpg",
      "/images/燕窝/图库/2.jpg",
      "/images/燕窝/图库/mmexport1584147763220.jpg",
      "/images/燕窝/图库/mmexport1589393741606.jpg",
      "/images/燕窝/图库/mmexport1584579612551.jpg",
      "/images/燕窝/图库/mmexport1593858954723.jpg",
      "/images/燕窝/图库/96f63986b0765c7417545f94ccd21660.jpg",
      "/images/燕窝/图库/mmexport1584579615093.jpg",
      "/images/燕窝/图库/mmexport1596274331279.jpg",
      "/images/燕窝/图库/IMG_20200121_152519_mh1581861185568.jpg",
      "/images/燕窝/图库/IMG_20200326_203143_mh1586729255755.jpg",
      "/images/燕窝/图库/mmexport1584896421037.jpg",


    ]

  }
};

export default yanwo;
